import routeNames from 'routes/routeNames'

const BreadcrumbsNameMapping = {
  [routeNames.cacheRoute]: 'cache.header',
  [routeNames.companiesRoute]: 'Company.PageTitle',
  [routeNames.companiesRouteEdit]: 'global.edit',
  [routeNames.companiesRouteNew]: 'global.new',
  [routeNames.shopsRoute]: 'shop.page_title',
  [routeNames.shopsRouteCompanies]: 'shop.page_title',
  [routeNames.shopsRouteEdit]: 'global.edit',
  [routeNames.shopsRouteNew]: 'global.new',
  [routeNames.employeesRoute]: 'setting_employee.page_title',
  [routeNames.employeesRouteEdit]: 'global.edit',
  [routeNames.employeesRouteNew]: 'global.new',
  [routeNames.externalSystemsRoute]: 'external-system-form.header',
  [routeNames.externalSystemsRouteEdit]: 'global.edit',
  [routeNames.externalSystemsRouteNew]: 'global.new',
  [routeNames.companyLicensesRoute]: 'global.licenses',
  [routeNames.companyLicensesRouteEdit]: 'global.edit',
  [routeNames.companyLicensesRouteNew]: 'global.new',
  [routeNames.productGroupRoute]: 'productgroup.page_title',
  [routeNames.productGroupRouteTree]: 'global.edit',
  [routeNames.mainProductGroupRouteEdit]: 'productgroup.page_title_group',
  [routeNames.subProductGroupRouteEdit]: 'productgroup.page_title_subgroup',
  [routeNames.conceptsRoute]: 'Concepts.PageTitle',
  [routeNames.conceptsRouteEdit]: 'global.edit',
  [routeNames.conceptsRouteNew]: 'global.new',
  [routeNames.releaseNotesRoute]: 'releasenotes.page_title',
  [routeNames.releaseNotesRouteEdit]: 'global.edit',
  [routeNames.releaseNotesRouteNew]: 'global.new',
  [routeNames.telesalesRoute]: 'global.menu_telesales',
  [routeNames.themesRoute]: 'theme.page_title',
  [routeNames.themesRouteNew]: 'global.new',
  [routeNames.themesRouteEdit]: 'global.edit',
  [routeNames.wholesaleRoute]: 'wholesale.page_title',
  [routeNames.wholesaleRouteEdit]: 'global.edit',
  [routeNames.wholesaleRouteNew]: 'global.new',
  [routeNames.wholesaleFormRouteListPage]: 'wholesale.page_title_form',
  [routeNames.warrantyRoute]: 'productWarrantyClaim.title',
  [routeNames.warrantyRouteEdit]: 'global.edit',
  [routeNames.messagesRoute]: 'global.messages',
  [routeNames.messagesRouteEdit]: 'global.edit',
  [routeNames.messagesRouteNew]: 'global.new',
  [routeNames.statsRoute]: 'global.statistics',
  [routeNames.shopsStatsRoute]: 'global.stats.shops',
  [routeNames.vehiclesStatsRoute]: 'global.stats.vehicles',
  [routeNames.ordersStatsRoute]: 'global.stats.orders',
  [routeNames.orderLinesStatsRoute]: 'global.stats.orderlines',
  [routeNames.accountsStatsRoute]: 'global.stats.accounts',
  [routeNames.appointmentsStatsRoute]: 'global.stats.appointments',
  [routeNames.invoicesStatsRoute]: 'global.stats.invoices',
  [routeNames.vehicleInvoicesStatsRoute]: 'global.stats.vehicle_invoices',
  [routeNames.bankHolidaysRoute]: 'bank_holidays.title',
  [routeNames.bankHolidaysRouteEdit]: 'bank_holidays.edit_holiday',
  [routeNames.bankHolidaysRouteNew]: 'bank_holidays.new_holiday',
  [routeNames.regionsRoute]: 'bank_holidays.regions',
  [routeNames.regionsRouteNew]: 'bank_holidays.new_region',
  [routeNames.regionsRouteEdit]: 'bank_holidays.edit_region',
  [routeNames.externalGMSRoute]: 'external_gms.title',
  [routeNames.externalGMSRouteNew]: 'global.new',
  [routeNames.externalGMSRouteEdit]: 'global.edit',
  [routeNames.licensesRoute]: 'global.licenses',
  [routeNames.distributorRouteNew]: 'global.new',
  [routeNames.distributorRouteEdit]: 'global.edit',
  [routeNames.accountSettingsRoute]: 'global.account_settings',
  [routeNames.accountancyRoute]: 'global.accountancy',
  [routeNames.defaultRevenueRoute]: 'global.default-revenue-group',
  [routeNames.accountancySoftwareRoute]: 'global.administration_filter',
  [routeNames.roadAssistance]: 'RoadAssistance.title',
  [routeNames.roadAssistanceNew]: 'global.new',
  [routeNames.roadAssistanceEdit]: 'global.edit',
  // New mappings
  [routeNames.offerPackage]: 'LKQ.OfferPackage',
  [routeNames.onBoard]: 'LKQ.onBoard',
  [routeNames.profileRoute]: 'LKQ.Profile',
  [routeNames.detailsRoute]: 'LKQ.Details',
  [routeNames.editingConcepts]: 'LKQ.EditConcepts',
  [routeNames.conceptsRoute2]: 'LKQ.Concepts2',
  [routeNames.manageCustomerAccessRoute]: 'LKQ.ManageCustomerAccess',
  [routeNames.pendingEmailLogRoute]: 'LKQ.PendingEmailLogRoute',
  [routeNames.emailContentRoute]: 'LKQ.EmailContentRoute',
  [routeNames.pendingEmailAttachment]: 'LKQ.PendingEmailAttachment',
  [routeNames.salesGroupsRoute]: 'LKQ.SalesGroups',
  [routeNames.alerts]: 'LKQ.Alerts',
  [routeNames.configuration]: 'LKQ.Configuration',
  [routeNames.accountancyErrorList]: 'global.failed_accountancy_export'
}

export default BreadcrumbsNameMapping
